<template>
    <div class="GroupList" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>GROUP SESSIONS <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span> <span><font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewModal()" class="olive-green-text pointer" /></span></h2>
            <div class="table-filters client-list" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Group Status:</label>
                            <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable()">
                                <option value="Scheduled and Recent">Scheduled and Recent</option>
                                <option value="Past">Past</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Catchement Area:</label>
                            <select class="form-control" v-model="Filters.Zone" @change="RefreshDataTable">
                                <option v-for="option in [{text:'All',value:null},{text:'5',value:'5'},{text:'6',value:'6'},{text:'7',value:'7'}]" v-bind:value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{NumberOfRecords}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Records:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="RecordTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="datatableid">

                <template slot="RecordLink" scope="props">
                    <div class="ChildRecordLink">
                        <span class="underline pointer" @click="ShowEditModal(props.rowData.Id)">{{ props.rowData.GroupName }}</span>
                    </div>
                </template>
            </vuetable>
        </div>

        <!--CREATE NEW APPOINTMENT-->
        <b-modal ref="modal-group-detail" size="lg" title="GROUP DETAILS" hide-footer>
            <b-container>
                <b-form @submit="CreateUpdateGroup">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Group Name:</label>
                                <input type="text" v-model="TargetRecord.GroupName" required class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <textarea class="form-control" v-model="TargetRecord.GroupDescription" rows="4"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Date of Group:</label>
                                <flat-pickr v-model="TargetRecord.DateHeld" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Incentive Amount Spent:</label>
                                <input type="number" step=".01" v-model="TargetRecord.IncentiveAmount" required class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Catchement Area:</label>
                                <select v-model="TargetRecord.Zone" required class="form-control">
                                    <option :value="null"></option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Misc. Comments:</label>
                                <textarea class="form-control" v-model="TargetRecord.Comments" rows="4"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <div v-if="TargetRecord.Id">
                                <div>
                                    <h3>Attendee List:</h3>
                                    <div class="form-group">
                                        <label>Add Attendee:</label>
                                        <v-select :options="ClientEnrollmentsList" label="label" :reduce="option => option.Id" v-model="SelectedClient" @input="AddAttendee">
                                            <template #search="{attributes, events}">
                                                <input class="vs__search"
                                                       v-bind="attributes"
                                                       v-on="events" />
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Attendees:</label>
                                        <p v-for="attendee in TargetRecord.Attendees">
                                            {{ attendee.ClientSubProgramMembership.Client.Person.FullName }} <span><font-awesome-icon :icon="['fa', 'trash-alt']" v-on:click="RemoveAttendee(attendee.ClientSubProgramMembershipID)" class="red pointer" /></span>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal()">
                                CANCEL
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="!TargetRecord.Id" size="md" variant="success" type="submit">
                                CREATE NEW GROUP
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="danger" @click="DeleteRecord()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import services

    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        created() {
            EventBus.$on('global-update-initiated', this.GetRecords);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                NumberOfRecords: '',
                search: "",
                Records: [],
                TargetRecord: {},
                SelectedClient: {},
                Filters: {
                    Status: "Scheduled and Recent",
                    Zone: null,
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                RecordTableOptions: {
                    Fields: [
                        {
                            name: '__slot:RecordLink',
                            title: 'Name',
                            sortField: 'GroupName',
                        },
                        {
                            name: 'GroupDescription',
                            title: "DESCRIPTION",
                            sortField: 'GroupDescription',
                        },
                        {
                            name: 'DateHeld',
                            title: "DATE",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DateHeld',
                        },
                        {
                            name: 'Zone',
                            title: 'CATCHEMENT',
                            sortField: 'Zone',
                        },
                        {
                            name: 'AttendeeCount',
                            title: "ATTENDEES",
                            sortField: 'AttendeeCount',
                        },
                        
                        {
                            name: 'IncentiveAmount',
                            title: "INCENTIVE",
                            sortField: 'IncentiveAmount',
                        },
                        
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetRecords(true);
                
            },
            GetRecords(displayLoad = false) {
                this.$MasterAPI.ExecuteRequest("GET", "TAY/GroupSessions", this.Filters, this.GetRecordsSuccess,()=>{}, displayLoad);
            },
            GetRecordsSuccess(response) {
                this.Records = response.data.data;
                this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultVal = '') {
              return (value == null)
                ? defaultVal
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenRecord(groupSessionId) {
                //OPEN RECORD----------------------------------------------------
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.Records);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfRecords = visibleData.length;
                return visibleData;                  
            },
            //RECORD MANAGEMENT METHODS
            CreateUpdateGroup(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PUT", "TAY/GroupSessions", this.TargetRecord, this.CreateUpdateGroupSuccess, () => { }, true);
            },
            CreateUpdateGroupSuccess(response) {
                this.GetRecords(true);
                this.$refs['modal-group-detail'].hide();
            },
            ShowNewModal() {
                this.TargetRecord = {};
                this.$refs['modal-group-detail'].show();
            },
            ShowEditModal(id) {
                this.$MasterAPI.ExecuteRequest("GET", "TAY/GroupSessions/" + id, {}, this.ShowEditModalSuccess, () => { }, true);
            },
            ShowEditModalSuccess(response) {
                this.TargetRecord = response.data.data;
                this.$refs['modal-group-detail'].show();
            },
            CancelModal() {
                this.$refs['modal-group-detail'].hide();
            },
            DeleteRecord() {
                this.$MasterAPI.ExecuteRequest("DELETE", "TAY/GroupSessions/" + this.TargetRecord.Id, {}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.GetRecords(true);
                this.$refs['modal-group-detail'].hide();
            },
            UpdateAppointmentLabel() {
                let vm = this;
                this.$store.state.Clients.ClientEnrollmentsList.map(function (client) {
                    if (client.DischargeDate != null)
                        return client.label = client.ClientName + ' ' + vm.formatDate(client.ReferralDate) + ' - ' + vm.formatDate(client.DischargeDate);
                    else {
                        return client.label = client.ClientName;
                    }
                });
            },
            AddAttendee() {
                this.$MasterAPI.ExecuteRequest("PATCH", "TAY/GroupSessions/AddAttendee", { GroupSessionID: this.TargetRecord.Id, ClientSubProgramMembershipID: this.SelectedClient }, this.AddAttendeeSuccess, () => { }, true);
            },
            AddAttendeeSuccess(response) {
                this.SelectedClient = {};
                this.ShowEditModal(response.data.data.GroupSessionID);
                this.GetRecords();
            },
            RemoveAttendee(Id) {
                this.$MasterAPI.ExecuteRequest("PATCH", "TAY/GroupSessions/RemoveAttendee", { GroupSessionID: this.TargetRecord.Id, ClientSubProgramMembershipID: Id }, this.RemoveAttendeeSuccess, () => { }, true);
            },
            RemoveAttendeeSuccess(response) {
                this.SelectedClient = {};
                this.ShowEditModal(response.data.data.GroupSessionID);
                this.GetRecords();
            }
        },
        components: {
            Vuetable,
            flatPickr,
            vSelect
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            ClientEnrollmentsList: function () {
                this.UpdateAppointmentLabel();
                return this.$store.state.Clients.ClientEnrollmentsList;
            },
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            //Get Child Records*/
            this.GetRecords(true);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>